import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "pg_lang";
export const DEFAULT_LANG = "hu";

const LangContext = createContext({ lang: DEFAULT_LANG, setLang: () => {}, t: (k) => k });

export const translations = {
  hu: {
    nav: {
      products: "Termékeink",
      technology: "Vezérlés",
      applications: "Alkalmazások",
      faq: "GYIK",
      gallery: "Galéria",
      inquire: "Ajánlatkérés",
    },
    hero: {
      tag: "",
      title_1: "Privát szféra,",
      title_2: "egy érintésre.",
      subtitle:
        "Intelligens likvid kristállyal ellátott fólia, amely a másodperc tizedrésze alatt vált át opálosból kristálytisztává. Érintsd meg a távirányítót, és próbáld ki az átalakulást.",
      cta_explore: "Termékeink",
      cta_consult: "Konzultáció kérése",
      status_on: "Privát mód",
      status_off: "Átlátszó",
      tap_to_switch: "Érintsd meg a váltáshoz",
      scroll: "Görgess",
      slider_hint: "Húzd",
    },
    products: {
      overline: "Termékeink",
      title_1: "A privát szféra",
      title_2: "négy állapota",
      intro:
        "Minden PrivacyGlass™ tábla repülésipari minőségű PDLC fóliával készül, egyedi méretre laminálva, az Ön specifikációi szerint.",
      cta: "Ajánlatkérés",
      estimator: {
        title: "Árkalkulátor",
        subtitle:
          "Add meg a felületek méretét, és azonnal kiszámoljuk a becsült árat.",
        unit_price_prefix: "Egységár",
        surface_label: "Felület",
        width: "Szélesség",
        height: "Magasság",
        cm: "cm",
        area: "Terület",
        add_surface: "További felület hozzáadása",
        remove_surface: "Felület eltávolítása",
        total_area: "Összes felület",
        total_price: "Becsült ár",
        from_suffix: "-tól",
        close: "Bezárás",
        proceed: "Tovább az ajánlatkéréshez",
        empty_hint:
          "Add meg legalább egy felület szélességét és magasságát a becsléshez.",
        prefill: {
          product: "Termék",
          unit_price: "Egységár",
          surfaces: "Felületek",
          surface: "Felület",
          total_area: "Összes felület",
          estimated_price: "Becsült ár",
          location: "Helyszín",
          location_hint: "(kérjük adja meg)",
          notes: "Megjegyzés",
          currency: "Ft",
          per_m2: "/ m²",
          from_suffix: "-tól",
        },
      },
      items: {
        standard: {
          name: "PrivacyGlass™ Standard",
          tagline: "Opálos → Tiszta",
          description:
            "Alaphelyzetben átláthatatlan, feszültség alatt átlátszó. Letisztult és megbízható megoldás mindennapi használathoz.",
          specs: [
            { label: "Szín", value: "Fehér" },
            { label: "Átláthatóság", value: "88%" },
            { label: "UV és Infra védelem", value: "90%-os szűrés" },
            { label: "Kapcsolási sebesség", value: "~50ms" },
            { label: "Feszültség", value: "48–60V AC" },
            { label: "Vastagság", value: "0,5 mm" },
            { label: "Frekvenciatartomány", value: "50–60Hz" },
            { label: "Fogyasztás", value: "~3–7 W/m²" },
            { label: "Élettartam", value: "10.000.000+ ciklus" },
            { label: "Garancia", value: "5 év" },
            { label: "Ár", value: "55.000 Ft/m²-től" },
          ],
        },
        premium: {
          name: "PrivacyGlass™ Premium",
          tagline: "Opálos → Tiszta",
          description:
            "Alaphelyzetben átláthatatlan, feszültség alatt átlátszó. Letisztult és megbízható megoldás mindennapi használathoz.",
          specs: [
            { label: "Szín", value: "Fehér" },
            { label: "Átláthatóság", value: "92%" },
            { label: "UV és Infra védelem", value: "95%-os szűrés" },
            { label: "Kapcsolási sebesség", value: "~10ms" },
            { label: "Feszültség", value: "48–60V AC" },
            { label: "Vastagság", value: "0,5 mm" },
            { label: "Frekvenciatartomány", value: "50–60Hz" },
            { label: "Fogyasztás", value: "~1–3 W/m²" },
            { label: "Élettartam", value: "50.000.000+ ciklus" },
            { label: "Garancia", value: "5 év" },
            { label: "Ár", value: "75.000 Ft/m²-től" },
          ],
        },
      },
    },
    technology: {
      title: "Vezérlés",
      devices: {
        remote: {
          name: "RF Távirányító",
          description:
            "Kompakt, hosszú élettartamú távirányító – minden szettünk alapfelszereltsége. Több zóna párosítható, falra szerelhető tartóval szállítjuk.",
          tag: "Alapfelszereltség",
        },
        wall: {
          name: "Fali Kapcsoló",
          description:
            "Diszkrét, dizájnos érintőkapcsoló a falba süllyesztve – minden klasszikus világításkapcsolóval kompatibilis, villanyszerelést a megrendelő biztosítja.",
          tag: "Beépített megoldás",
        },
        app: {
          name: "Mobil Alkalmazás",
          description:
            "iOS és Android applikáció Wi-Fi gateway-jel – időzítés, jelenetek, hangvezérlés és integráció okosotthon rendszerekbe.",
          tag: "Okosotthon",
        },
      },
    },
    pdlc: {
      title: "Technológia",
      layers: [
        "PE védőfólia",
        "ITO vezetőréteg",
        "PDLC réteg",
        "ITO vezetőréteg",
        "OCA ragasztó",
        "PET hordozóréteg",
        "Szilikagél öntapadó réteg",
        "PET távtartó fólia",
      ],
    },
    applications: {
      title: "Alkalmazási területek",
      tiles: [
        { name: "Lounge" },
        { name: "Tárgyaló" },
        { name: "Privát Iroda" },
        { name: "Fodrászat" },
        { name: "Edzőterem" },
        { name: "Iroda" },
        { name: "Otthonok" },
      ],
    },
    gallery: {
      overline: "Portfólió",
      title_1: "Az építész",
      title_2: "galériája.",
      intro: "",
      items: [
        { title: "Meridian Tower", type: "Üzleti", location: "Athén, Görögország", coverage: "223 m²" },
        { title: "Villa Serenità", type: "Lakossági", location: "Szantorini, Görögország", coverage: "80 m²" },
        { title: "M/Y Phantom", type: "Tengeri", location: "Földközi-tenger", coverage: "32 m²" },
        { title: "Skyline Penthouse", type: "Lakossági", location: "Amalfi-part, Olaszország", coverage: "167 m²" },
      ],
    },
    contact: {
      overline: "Indítsa el projektjét",
      title_1: "Tervezzük meg",
      title_2: "az Ön privát terét.",
      intro:
        "Ossza meg velünk a részleteket, és mi 24 órán belül válaszolunk minden kérdésére!",
      info: {
        email_label: "E-mail",
        atelier_label: "Telefonszám",
        atelier_value: "+36 70 635 9033",
        hours_label: "Elérhetőség",
        hours_value: "Hétfő–Péntek: 09:00 – 19:00",
      },
      labels: {
        name: "Teljes név",
        email: "E-mail",
        phone: "Telefon",
        project_type: "Projekt típusa",
        product_interest: "Érdeklődési termék",
        message: "Üzenet",
      },
      placeholders: {
        name: "Kovács Lilla",
        email: "kovacslilla@gmail.com",
        phone: "+36 00 000 0000",
        message: "Méretek, helyszín, ütemterv és építészeti részletek...",
      },
      project_types: ["Lakossági", "Üzleti", "Vendéglátás", "Egészségügy", "Autóipar"],
      product_options: [
        "PrivacyGlass™ Standard",
        "PrivacyGlass™ Premium",
        "Még nem döntöttem el",
      ],
      submit: "Ajánlatkérés elküldése",
      submitting: "Küldés...",
      consent:
        "A beküldéssel hozzájárul ahhoz, hogy ügyfélszolgálatunk egyszeri konzultációs visszajelzéssel felvegye Önnel a kapcsolatot. Marketinglistára soha nem kerül.",
      error_required: "Kérjük, töltse ki a kötelező mezőket.",
      error_generic: "Hiba történt. Kérjük, próbálja újra.",
      success:
        "Köszönjük – ajánlatkérését megkaptuk. 24 órán belül felvesszük Önnel a kapcsolatot.",
    },
    footer: {
      tagline:
        "Építészeti okosüveg megoldások, amelyek elválasztják a menedéket a tájképtől.",
      products: "Termékeink",
      company: "Vállalat",
      studio: "Kapcsolat",
      copyright: "Minden jog fenntartva.",
      cert_1: "PDLC európai mérnöki munka",
      cert_2: "ISO 9001 tanúsítvány",
    },
  },
  en: {
    nav: {
      products: "Products",
      technology: "Control",
      applications: "Applications",
      faq: "FAQ",
      gallery: "Gallery",
      inquire: "Inquire",
    },
    hero: {
      tag: "",
      title_1: "Privacy,",
      title_2: "on demand.",
      subtitle:
        "Intelligent liquid crystal foil that transforms from opaque to crystal-clear in under a tenth of a second. Tap the remote to try the transition.",
      cta_explore: "Products",
      cta_consult: "Request a consultation",
      status_on: "Privacy On",
      status_off: "Transparent",
      tap_to_switch: "Tap to switch",
      scroll: "Scroll",
      slider_hint: "Drag",
    },
    products: {
      overline: "Products",
      title_1: "Four states of",
      title_2: "architectural privacy.",
      intro:
        "Every PrivacyGlass™ panel is hand-engineered with aerospace-grade PDLC film, custom-laminated to your specifications.",
      cta: "Inquire",
      estimator: {
        title: "Cost estimator",
        subtitle:
          "Enter your surface dimensions and we'll calculate the estimated price instantly.",
        unit_price_prefix: "Unit price",
        surface_label: "Surface",
        width: "Width",
        height: "Height",
        cm: "cm",
        area: "Area",
        add_surface: "Add another surface",
        remove_surface: "Remove surface",
        total_area: "Total surface",
        total_price: "Estimated price",
        from_suffix: " and up",
        close: "Close",
        proceed: "Continue to inquiry",
        empty_hint:
          "Enter at least one surface's width and height to see an estimate.",
        prefill: {
          product: "Product",
          unit_price: "Unit price",
          surfaces: "Surfaces",
          surface: "Surface",
          total_area: "Total surface",
          estimated_price: "Estimated price",
          location: "Location",
          location_hint: "(please specify)",
          notes: "Notes",
          currency: "HUF",
          per_m2: "/ m²",
          from_suffix: " and up",
        },
      },
      items: {
        standard: {
          name: "PrivacyGlass™ Standard",
          tagline: "Frosted → Clear",
          description:
            "Opaque by default, transparent when powered. A clean, dependable solution for everyday use.",
          specs: [
            { label: "Color", value: "White" },
            { label: "Transparency", value: "88%" },
            { label: "UV & IR protection", value: "90% filtration" },
            { label: "Switching speed", value: "~50ms" },
            { label: "Voltage", value: "48–60V AC" },
            { label: "Thickness", value: "0.5 mm" },
            { label: "Frequency range", value: "50–60Hz" },
            { label: "Power consumption", value: "~3–7 W/m²" },
            { label: "Lifespan", value: "10,000,000+ cycles" },
            { label: "Warranty", value: "5 years" },
            { label: "Price", value: "from 55,000 HUF/m²" },
          ],
        },
        premium: {
          name: "PrivacyGlass™ Premium",
          tagline: "Frosted → Clear",
          description:
            "Opaque by default, transparent when powered. A clean, dependable solution for everyday use.",
          specs: [
            { label: "Color", value: "White" },
            { label: "Transparency", value: "92%" },
            { label: "UV & IR protection", value: "95% filtration" },
            { label: "Switching speed", value: "~10ms" },
            { label: "Voltage", value: "48–60V AC" },
            { label: "Thickness", value: "0.5 mm" },
            { label: "Frequency range", value: "50–60Hz" },
            { label: "Power consumption", value: "~1–3 W/m²" },
            { label: "Lifespan", value: "50,000,000+ cycles" },
            { label: "Warranty", value: "5 years" },
            { label: "Price", value: "from 75,000 HUF/m²" },
          ],
        },
      },
    },
    technology: {
      title: "Control",
      devices: {
        remote: {
          name: "RF Remote",
          description:
            "A compact, long-life handheld remote — included with every kit. Pairs with multiple zones and ships with a wall-mount cradle.",
          tag: "Included as standard",
        },
        wall: {
          name: "Wall Switch",
          description:
            "A discreet, designer touch switch flush-mounted in the wall — compatible with standard lighting wiring (electrical install is the client's responsibility).",
          tag: "Built-in solution",
        },
        app: {
          name: "Mobile App",
          description:
            "iOS and Android app with a Wi-Fi gateway — schedules, scenes, voice control and integrations with major smart-home platforms.",
          tag: "Smart home",
        },
      },
    },
    pdlc: {
      title: "Technology",
      layers: [
        "PE protective film",
        "ITO conductive film",
        "PDLC layer",
        "ITO conductive film",
        "OCA glue",
        "PET carrier film",
        "Silica gel adhesive layer",
        "PET release film",
      ],
    },
    applications: {
      title: "Applications",
      tiles: [
        { name: "Lounge" },
        { name: "Boardroom" },
        { name: "Private Office" },
        { name: "Barber & Salon" },
        { name: "Gym" },
        { name: "Office" },
        { name: "Homes" },
      ],
    },
    gallery: {
      overline: "Portfolio",
      title_1: "The architect's",
      title_2: "gallery.",
      intro: "",
      items: [
        { title: "Meridian Tower", type: "Commercial", location: "Athens, Greece", coverage: "2,400 sq ft" },
        { title: "Villa Serenità", type: "Residential", location: "Santorini, Greece", coverage: "860 sq ft" },
        { title: "M/Y Phantom", type: "Marine", location: "Mediterranean Sea", coverage: "340 sq ft" },
        { title: "Skyline Penthouse", type: "Residential", location: "Amalfi Coast, Italy", coverage: "1,800 sq ft" },
      ],
    },
    contact: {
      overline: "Start your project",
      title_1: "Let's design",
      title_2: "your private space.",
      intro:
        "Share a few details and we'll get back to you within 24 hours with answers to all your questions!",
      info: {
        email_label: "Email",
        atelier_label: "Phone",
        atelier_value: "+36 70 635 9033",
        hours_label: "Availability",
        hours_value: "Mon–Fri: 09:00 – 19:00",
      },
      labels: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        project_type: "Project type",
        product_interest: "Product interest",
        message: "Message",
      },
      placeholders: {
        name: "Lilla Kovács",
        email: "kovacslilla@gmail.com",
        phone: "+36 00 000 0000",
        message: "Dimensions, location, timeline, and any architectural details...",
      },
      project_types: ["Residential", "Commercial", "Hospitality", "Healthcare", "Automotive"],
      product_options: [
        "PrivacyGlass™ Standard",
        "PrivacyGlass™ Premium",
        "Not sure yet",
      ],
      submit: "Send inquiry",
      submitting: "Sending...",
      consent:
        "By submitting, you agree to receive a one-time consultation follow-up from our studio. No marketing lists, ever.",
      error_required: "Please complete all required fields.",
      error_generic: "Something went wrong. Please try again.",
      success:
        "Thank you — your inquiry has been received. We'll be in touch within 24 hours.",
    },
    footer: {
      tagline:
        "Architectural smart-glass solutions that define the boundary between sanctuary and scenery.",
      products: "Products",
      company: "Company",
      studio: "Contact",
      copyright: "All rights reserved.",
      cert_1: "PDLC engineered in Europe",
      cert_2: "ISO 9001 certified",
    },
  },
};

function getByPath(obj, path) {
  return path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "en" || stored === "hu" ? stored : DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const setLang = (l) => setLangState(l === "en" ? "en" : "hu");

  const t = (path) => {
    const val = getByPath(translations[lang], path);
    if (val === undefined) return getByPath(translations.en, path) ?? path;
    return val;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
